const galleryThumbTransition = (
    THUMB_WIDTH: number,
    numOfSlides: number,
    currentTabGroup: number,
    noOfGroups: number,
    thumbGroups: number[][],
) => {
    const MAX_TABS = 5;
    const currentGroup = thumbGroups[currentTabGroup - 1];
    if (!currentGroup) {
        return 0;
    }
    const groupIdx = thumbGroups.indexOf(currentGroup);
    const splitGroup = thumbGroups.slice(0, groupIdx).flat();

    const maxTrackWidth = numOfSlides * THUMB_WIDTH - MAX_TABS * THUMB_WIDTH;

    const trackWidth = -(splitGroup.length * THUMB_WIDTH);

    const translateTrackWidth =
        currentTabGroup === noOfGroups ? -maxTrackWidth : trackWidth;
    return currentTabGroup > 1 ? translateTrackWidth : 0;
};

export default galleryThumbTransition;
